import { faqs, testimonials } from '@/mocks/comics';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function FaqSection() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            读者口碑
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            听听读者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-100 rounded-xl p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{t.comment}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-sm font-medium text-foreground-900">
                  {t.name}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              关于妖精动漫的常见疑问
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-xl overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() =>
                    setExpandedIndex(expandedIndex === idx ? null : idx)
                  }
                >
                  <span className="text-sm font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform text-lg flex-shrink-0 ${
                      expandedIndex === idx ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {expandedIndex === idx && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-white rounded-full font-medium text-sm hover:bg-secondary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line"></i>
            了解更多关于妖精动漫
          </Link>
        </div>
      </div>
    </section>
  );
}